import appConfig from 'app/app.conf.json';

export default appConfig;



// WEBPACK FOOTER //
// ./src/modules/lsp-config/lsp-config.js